<template>
    <div class="login">
        <p class="welcome-text">
            请输入新的密码 !
        </p>
        <div class="login-form">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                class="demo-ruleForm">
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" @keyup.enter.native="submitForm('ruleForm')" autocomplete="off" placeholder="请确认密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <span class="btn" @click="$router.push({path:'/login'})">登录</span>
                    <span class="btn" @click="resetForm('ruleForm')">清空</span>
                    <span class="btn" type="primary" @click="submitForm('ruleForm')">
                        <i v-if="status">找回密码</i>
                        <i class="el-icon-loading lod" v-else></i>
                    </span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    // 验证密码规则
    function test(s) {
        if (/^(\d)\1+$/.test(s)) return false; // 全一样
        var str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) - pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺增
        str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) + pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺减
        return true;
    }
    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (!test(value)) {
                        callback(new Error('密码过于简单'));
                    } else {
                        callback();
                    };
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (value != this.ruleForm.pass) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    };
            };
            return {
                status: true,
                ruleForm: {
                    pass: '',
                    checkPass: '',
                },
                rules: {
                    pass: [
                        { min: 8, max: 16, message: '密码长度在6到16个字符', trigger: 'blur' },
                        { required: true, validator: validatePass, trigger: 'blur' },
                    ],
                    checkPass: [
                        { min: 8, max: 16, message: '密码长度在6到16个字符', trigger: 'blur' },
                        { required: true, validator: validatePass2, trigger: 'blur' },
                    ],
                }
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$confirm('即将重置密码，请确认已牢记新密码', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.status = false;
                            let param = new URLSearchParams();
                            param.append("sequence", this.$route.query.s);
                            param.append("pwd", this.ruleForm.pass);
                            // 请求数据
                            this.$http.postChangeResetPwd(param).then(response => {
                                // 响应码为200的时候代码成功
                                if (response.code == 200) {
                                    this.$message({
                                        message: '修改成功!',
                                        type: 'success',
                                        customClass: 'hint-message',
                                        center: true
                                    });
                                    this.resetForm('ruleForm');
                                    this.$router.push({
                                        query:{}
                                    })
                                // 其它情况
                                }else{
                                    this.$message({
                                        message: response.msg,
                                        type: 'warning',
                                        customClass: 'hint-message',
                                        center: true
                                    });
                                }
                                this.status = true;
                            }).catch(err => {
                                this.$message({
                                    message: '网络出错',
                                    type: 'error',
                                    customClass: 'hint-message',
                                    center: true
                                });
                                this.status = true;
                            });
                        }).catch(() => {
                            this.status = true;
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>
<style scoped>
    .login {
        width: 1030px;
        margin: 0 auto;
    }

    .welcome-text {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        padding-top: 5%;
        padding-bottom: 2%;
    }

    .login-form {
        /* background-color: #efefef; */
        padding: 40px 100px 20px 15px;
        border-radius: 10px;
        width: 400px;
        margin: 0 auto;
        text-align: center;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        color: white;
        border: 0;
        background-color: #A7231E;
        font-weight: bold;
        padding: 5px 10px;
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
        background-color: rgb(207, 50, 44);
    }

    .verification_code {
        display: inline-block;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        width: 90px;
        margin-left: 8px;
        height: 38px;
        background-color: #FAFAFA;
        cursor: pointer;
        vertical-align: top;
    }

    .verification_code img {
        position: relative;
        top: 5px
    }

    .lod {
        display: inline-block;
        width: 56px;
    }
</style>